export default __webpack_public_path__ + "static/media/612.b1b87d8d.gif";